<template>
  <main>
    <section
      id="home-header"
      class="d-flex flex-column justify-content-center align-items-center pt-4 pb-4"
    >
 
      <router-link class="header-play-button" to="/play">
        <img src="@/assets/img/play-button.png" eager />
      </router-link>
      <!--
       <Timer />
       -->
    </section>
    <section
      class="discord-home pt-4 pb-4 d-flex justify-content-center align-items-center"
      id="home-discord"
    >
      <div class="container">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-12 col-md-12 col-lg-5">
            <a
              href="https://discord.com/invite/nrpk"
              target="_blank"
              class="text-center discord-home--btn"
            >
              <h5
                class="mb-0 text-uppercase font-weight-bold text-white font-mondo"
              >
                Join our
              </h5>
              <h3
                class="mb-0 text-uppercase font-weight-bolder text-white font-mondo"
              >
                Discord
              </h3>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section
      class="d-flex justify-content-center align-items-center pt-5 pb-5"
      id="home-video"
    >
      <div class="container">
        <div class="row align-items-center justify-content-center gy-4 mt-2">
          <div class="col-12 col-sm-12 col-md-8 col-lg-5">
            <div class="featured-video-block">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/uDW-FbUspws"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-auto ml-0 ml-lg-5 text-center text-lg-left"
          >
            <h2 class="mb-3 text-uppercase text-white font-mondo">
              Video Spotlight
            </h2>
            <h5 class="paragraph--heading text-faded mb-4">
              Latest Community Video
            </h5>
            <a
              href="https://www.youtube.com/channel/UCejKsrY3HQnsq8oVhrrRwyg"
              target="_blank"
              class="btn"
              >View more<i class="fab fa-youtube ml-2"></i
            ></a>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="pt-2 pt-sm-5 pb-2 pb-sm-5 mt-2 mt-sm-2 mb-5 mb-sm-5" id="home-news">
            <div class="container">
                <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3 mb-sm-4">
                    <h4 class="page-title serif font-weight-bold mb-sm-0">Game Updates & News</h4>
                    <router-link to="/news" class="btn dark small">News Archive<i class="fas fa-long-arrow-alt-right ml-2"></i></router-link>
                </div>

                <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 gy-3">
                    <div class="col">
                        <div class="news-post-bg p-3 d-block w-100">
                            <a href="#" class="d-block w-100 news-post-img-bg p-3">
                                <div class="news-post-img">
                                    <img src="@/assets/img/news/news-post-example.jpg" lazy>
                                </div>
                            </a>
                            <div class="mt-3">
                                <p class="mb-1"><b>Game Updates</b> <span class="ml-1 mr-1">|</span> 25 April 2022</p>
                                <h5 class="mb-2 font-weight-bold">News Post Title</h5>
                                <a href="#" class="font-italic">Read More</a>
                            </div>

                        </div>
                    </div>
                    <div class="col">
                        <div class="news-post-bg p-3 d-block w-100">
                            <a href="#" class="d-block w-100 news-post-img-bg p-3">
                                <div class="news-post-img">
                                    <img src="@/assets/img/news/news-post-example-5.jpg" lazy>
                                </div>
                            </a>
                            <div class="mt-3">
                                <p class="mb-1"><b>Game Updates</b> <span class="ml-1 mr-1">|</span> 25 April 2022</p>
                                <h5 class="mb-2 font-weight-bold">News Post Title</h5>
                                <a href="#" class="font-italic">Read More</a>
                            </div>

                        </div>
                    </div>
                    <div class="col">
                        <div class="news-post-bg p-3 d-block w-100">
                            <a href="#" class="d-block w-100 news-post-img-bg p-3">
                                <div class="news-post-img">
                                    <img src="@/assets/img/news/news-post-example-3.jpg" lazy>
                                </div>
                            </a>
                            <div class="mt-3">
                                <p class="mb-1"><b>Game Updates</b> <span class="ml-1 mr-1">|</span> 25 April 2022</p>
                                <h5 class="mb-2 font-weight-bold">News Post Title</h5>
                                <a href="#" class="font-italic">Read More</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <div class="section-divider"></div>

    <section
      class="pt-5 pb-5 home-feature-row feature-row-4 d-flex justify-content-center align-items-center"
      id="home-feature-4"
    >
      <div class="container">
        <div
          class="row align-items-center justify-content-center justify-content-md-start gy-5"
        >
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-5 text-center text-lg-left"
          >
            <div class="mb-0">
              <h2 class="mb-3 text-uppercase text-white font-mondo">
                Real World Trading
              </h2>
              <p class="h5 paragraph--heading text-faded">
                Convert your in-game gold and items into real-world currency
                through our secure trading system.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="section-divider"></div>
    <section
      class="pt-5 pb-5 home-feature-row feature-row-3 d-flex justify-content-center align-items-center"
      id="home-feature-3"
    >
      <div class="container">
        <div class="row align-items-center justify-content-center gy-5">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-5 offset-lg-7 text-center text-lg-left"
          >
            <div class="mb-0">
              <h2 class="mb-3 text-uppercase text-white font-mondo">
                Doom of Mokhaiotl
              </h2>
              <p class="h5 paragraph--heading text-faded">
                Face the Doom of Mokhaiotl—a giant insect-like demonic boss in
                the Ruins of Mokhaiotl. Chase it deeper through delve levels
                for greater difficulty and rarer drops.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="section-divider"></div>
    <section
      class="pt-5 pb-5 home-feature-row feature-row-2 d-flex justify-content-center align-items-center"
      id="home-feature-2"
    >
      <div class="container">
        <div
          class="row align-items-center justify-content-center justify-content-md-start gy-5"
        >
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-5 text-center text-lg-left"
          >
            <div class="mb-0">
              <h2 class="mb-3 text-uppercase text-white font-mondo">Araxxor</h2>
              <p class="h5 paragraph--heading text-faded">
                Face off against Araxxor, a terrifying giant spider that lurks
                in its lair. This legendary boss uses deadly mechanics including
                web shields, minions, and devastating special attacks. Master
                all four paths to claim powerful rewards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="section-divider"></div>
    <section
      class="pt-5 pb-5 home-feature-row feature-row-1 d-flex justify-content-center align-items-center"
      id="home-feature-1"
    >
      <div class="container">
        <div class="row align-items-center justify-content-center gy-5">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-5 offset-lg-7 text-center text-lg-left"
          >
            <div class="mb-0">
              <h2 class="mb-3 text-uppercase text-white font-mondo">
                Yama
              </h2>
              <p class="h5 paragraph--heading text-faded">
                Challenge Yama, the Master of Pacts, in the depths of the Chasm
                of Fire. Fight solo or with a partner—master movement and
                prayer switching for Oathplate armour, the Soulflame horn, and
                the Yami pet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="section-divider"></div>
    <section class="pt-3 pb-1" id="home-play">
      <div class="container mt-5 mb-3 text-center">
        <h2 class="mb-3 text-uppercase text-white font-mondo">
          Ready to start playing?
        </h2>
        <div class="row justify-content-center mx-auto mb-3">
          <div class="col-12 col-md-10 col-lg-6">
            <p class="h5 paragraph--heading text-faded">
              Join the most famous RSPS in the scene! With a talented team and a
              commitment to listening to our community, we stop at nothing to
              deliver the best gameplay experience. Don’t miss the Fresh Start
              World launching this April!
            </p>
          </div>
        </div>
        <router-link class="mt-2 mt-sm-4 header-play-button" to="/play">
          <img src="@/assets/img/play-button.png" />
        </router-link>
      </div>
    </section>
  </main>
</template>
<script setup>
import Timer from "@/components/Timer";
</script>
<script>
export default {
  mounted() {
    document.body.classList.add("index-page");
  },
  beforeUnmount() {
    document.body.classList.remove("index-page");
  },
};
</script>
